import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import memoize from "micro-memoize";
import STRINGS from "./strings";
/**
 * Returns component strings.
 * @param {customStrings} customStrings passed by the consumer.
 * @param {minSelection} Minimum number of selections that can be made in Edit panel.
 * @param {maxSelection} Maximum number of selections that can be made in Edit panel.
 * @return Object Returns strings object merged with default custom strings.
 */

const getStrings = (customStrings, minSelection, maxSelection) => {
  let feedbackInstruction = "Select items to continue.",
      feedbackMinSelectionError = `Select at least ${minSelection} items to continue.`,
      feedbackMaxSelectionError = `Select up to ${maxSelection} items to continue.`;

  if (minSelection > 0 && maxSelection > 0) {
    feedbackInstruction = `Select between ${minSelection} and ${maxSelection} items to continue.`;
    feedbackMinSelectionError = `Fewer than ${minSelection} items selected.`;
    feedbackMaxSelectionError = `More than ${maxSelection} items selected.`;
  } else if (maxSelection > 0) {
    feedbackInstruction = `Select up to ${maxSelection} items to continue.`;
  } else if (minSelection > 0) {
    feedbackInstruction = `Select at least ${minSelection} items to continue.`;
  }

  const feedbackCustomStrings = {
    feedbackInstruction,
    feedbackMinSelectionError,
    feedbackMaxSelectionError
  };
  const componentStrings = customStrings === null ? _objectSpread(_objectSpread({}, STRINGS), feedbackCustomStrings) : _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, STRINGS), feedbackCustomStrings), customStrings), {}, {
    keyboardHelp: _objectSpread(_objectSpread({}, STRINGS.keyboardHelp), customStrings.keyboardHelp)
  });
  return componentStrings;
};
/**
 * Retains/shifts the focus to the cell in table after reorder/clear operations.
 * @param {boolean} focusTableCell - If true, focuses the last focused cell in table.
 * @param {object} panelNode
 */


export const handleTableCellFocus = (focusTableCell, panelNode) => {
  if (focusTableCell === true) {
    const cellToBeFocused = panelNode.querySelector("td[tabindex='0']");
    cellToBeFocused && cellToBeFocused.focus();
    return cellToBeFocused;
  }
};
export const getStringsMemoized = memoize(getStrings);